import { DivisonListingResp } from 'types/league/division'
import { LeagueFinalResp } from 'types/league/league'
import { OfficialConstraintResp } from 'types/league/officialConstraints'
import { TeamConstraintType } from 'types/league/teamConstraints'
import { create } from 'zustand'

interface SelectedItem {
  index: number
  item: string
}

const leagueEventStoreState = (set: any) => ({
  // counters and updates
  leagueStepCounter: 0,
  setLeagueStepCounter: (state: number) =>
    set(() => ({
      leagueStepCounter: state,
    })),
  isUpdatingDivision: false,
  setIsUpdatingDivision: (state: boolean) =>
    set(() => ({ isUpdatingDivision: state })),

  // datasets
  leagueData: null,
  setLeagueData: (state: LeagueFinalResp) =>
    set(() => ({
      leagueData: state,
    })),
  divisionData: null,
  setDivisionData: (state: DivisonListingResp) =>
    set(() => ({ divisionData: state })),
  timeSlots: null,
  setTimeSlots: (state: any) =>
    set(() => ({
      timeSlots: state,
    })),
  regions: [],
  setRegions: (state: string[]) => set(() => ({ regions: state })),

  //step 6 cost and estimates
  estimateCostPayload: {
    numOfStaff: 1,
    estimatedUnitStaffSalary: { min: 0, max: 0 },
    totalStaffSalary: { min: 0, max: 0 },
    venuePrice: { min: 0, max: 0 },
    estimatedTotalPrice: { min: 0, max: 0 },
    estimatedAvgTicketPrice: { min: 0, max: 0 },
  },
  setEstimateCostPayload: (state: any) =>
    set((currentState: any) => ({
      estimateCostPayload: { ...currentState.estimateCostPayload, ...state },
    })),

  // step 6 communication
  itemsToBring: [],
  setItemsToBring: (state: string[]) => set(() => ({ itemsToBring: state })),
  selectedItemToBring: undefined,
  setSelectedItemToBring: (state: undefined | SelectedItem) =>
    set(() => ({ selectedItemToBring: state })),
  selectedQuestions: [],
  setSelectedQuestions: (state: string[]) =>
    set(() => ({
      selectedQuestions: state,
    })),
  agreements: [],
  setAgreements: (state: string[]) => set(() => ({ agreements: state })),
  riskLevel: undefined,
  setRiskLevel: (state: 'low' | 'medium' | 'high') =>
    set(() => ({ riskLevel: state })),
  requiredDetails: null,
  setRequiredDetails: (state: any) => set(() => ({ requiredDetails: state })),
  selectedRequiredDocumentIds: [],
  setSelectedRequiredDocumentIds: (state: string[]) =>
    set(() => ({ selectedRequiredDocumentIds: state })),
  rulesAndRegulation: [],
  setRulesAndRegulation: (state: string[]) =>
    set(() => ({
      rulesAndRegulation: state,
    })),
  donationData: {
    allowDonation: false,
    preSelectedDonationAmounts: [],
  },
  setDonationData: (state: {
    allowDonation: boolean
    preSelectedDonationAmounts: number[]
  }) =>
    set(() => ({
      donationData: state,
    })),
  // constraints
  teamConstraintData: null,
  setTeamConstraintData: (state: TeamConstraintType) =>
    set(() => ({ teamConstraintData: state })),
  divisionConstraintData: null,
  setDivisionConstraintData: (state: any) =>
    set(() => ({ divisionConstraintData: state })),
  officialData: null,
  setOfficialData: (state: OfficialConstraintResp) =>
    set(() => ({
      officialData: state,
    })),

  additionalFeeData: undefined,
  setAdditionalFeeData: (state: any) =>
    set(() => ({
      additionalFeeData: state,
    })),

  // modal states
  addDevisionModal: false,
  setAddDevisonModal: (state: boolean) =>
    set(() => ({ addDevisionModal: state })),
  manageDivisionModal: false,
  setManageDivisionModal: (state: boolean) =>
    set(() => ({ manageDivisionModal: state })),
  addTimeModal: false,
  setAddTimeModal: (state: boolean) => set(() => ({ addTimeModal: state })),
  feeModal: false,
  setFeeModal: (state: boolean) => set(() => ({ feeModal: state })),

  // new todo will remove this comment
  roundsModal: false,
  setRoundsModal: (state: boolean) => set(() => ({ roundsModal: state })),
  timeSlotsModal: false,
  setTimeSlotsModal: (state: boolean) => set(() => ({ timeSlotsModal: state })),
  gameConstraintModal: false,
  setgameConstraintModal: (state: boolean) =>
    set(() => ({ gameConstraintModal: state })),
  travelConstraintModal: false,
  setTravelConstraintModal: (state: boolean) =>
    set(() => ({
      travelConstraintModal: state,
    })),
  rulesAndRegulationModal: false,
  setRulesAndRegulationModal: (state: boolean) =>
    set(() => ({
      rulesAndRegulationModal: state,
    })),

  copyTimeModal: false,
  setCopyTimeModal: (state: boolean) => set(() => ({ copyTimeModal: state })),
  teamConstraintModal: false,
  setTeamConstraintModal: (state: boolean) =>
    set(() => ({ teamConstraintModal: state })),
  addTeamConstraintModal: false,
  setAddTeamConstraintModal: (state: boolean) =>
    set(() => ({ addTeamConstraintModal: state })),
  divisionConstraintModal: false,
  setDivisionConstraintModal: (state: boolean) =>
    set(() => ({ divisionConstraintModal: state })),
  addDivisionConstraintModal: false,
  setAddDivisionConstraintModal: (state: boolean) =>
    set(() => ({ addDivisionConstraintModal: state })),
  // gameConstraintModal: false,
  // setgameConstraintModal: (state: boolean) =>
  //   set(() => ({ gameConstraintModal: state })),
  // travelConstraintModal: false,
  // setTravelConstraintModal: (state: boolean) =>
  //   set(() => ({
  //     travelConstraintModal: state,
  //   })),
  officialModal: false,
  setOfficialModal: (state: boolean) =>
    set(() => ({
      officialModal: state,
    })),
  addOfficialModal: false,
  setAddOfficialModal: (state: boolean) =>
    set(() => ({
      addOfficialModal: state,
    })),
  datesConstraints: false,
  setDatesConstraints: (state: boolean) =>
    set(() => ({
      datesConstraints: state,
    })),
  addRegionModal: false,
  setAddRegionModal: (state: boolean) =>
    set(() => ({
      addRegionModal: state,
    })),
  divisionNameModal: false,
  setDivisionNameModal: (state: boolean) =>
    set(() => ({
      divisionNameModal: state,
    })),
  divisionPriceModal: false,
  setDivisionPriceModal: (state: boolean) =>
    set(() => ({
      divisionPriceModal: state,
    })),
  itemsToBringModal: false,
  setItemsToBringModal: (state: boolean) =>
    set(() => ({ itemsToBringModal: state })),
  addItemModal: false,
  setAddItemModal: (state: boolean) => set(() => ({ addItemModal: state })),
  // active tab
  activeTab: '1',
  setActiveTab: (tab: string) => set(() => ({ activeTab: tab })),

  // ohterstates
})

export const leagueEventStore = create(leagueEventStoreState)
